import Config from '../../config.json';
import Keycloak from 'keycloak-js';
import { getKeycloakClientId, getKeycloakRealm } from '../utils/mandant';

const keycloak = new Keycloak({
  clientId: getKeycloakClientId(),
  realm: getKeycloakRealm(),
  url: process.env.REACT_APP_KEYCLOAK_URL || Config.REACT_APP_KEYCLOAK_URL
});

export default keycloak;
